import { NUMBER_SIZE } from '../../../../constants/size'
import { useTimeZone } from '../../../../hooks'
import { transposeToLocalTimezoneDate } from '../../../../utils/date'
import Button from '../../../Button'
import { SelectTags } from '../../../CustomSelect'

import { getTags } from './DatePickerTagControl.utils'

function DatePickerTagControl({
  containerRef,
  endValue,
  isOpen,
  label,
  startValue,
  time,
  onClear,
  onFocus,
  ...restProps
}) {
  const timezone = useTimeZone()

  const tags = getTags({
    endDate: transposeToLocalTimezoneDate(endValue, timezone),
    startDate: transposeToLocalTimezoneDate(startValue, timezone),
    time,
  })

  function handleClick(e) {
    onFocus?.(e)
  }

  return (
    <Button.White
      {...restProps}
      isGrey
      shadowed
      showTextTooltip
      elementRef={containerRef}
      height={NUMBER_SIZE.size32}
      isActive={isOpen}
      text={label}
      onClick={handleClick}
    >
      <SelectTags tags={tags} onClose={onClear} />
    </Button.White>
  )
}

export default DatePickerTagControl
